import { features } from '../../../mocks/news';

export default function Features() {
  return (
    <section id="feature" className="scroll-mt-24 py-12 md:py-16 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-10">
          <div>
            <span className="text-xs font-semibold text-primary-600 tracking-widest uppercase">DEEP DIVE</span>
            <h2 className="mt-1 font-heading text-2xl md:text-4xl font-black text-foreground-950">不止于瓜 · 深度阅读</h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            热闹散去之后，我们把镜头拉远，梳理时间线、还原各方说法，呈现事件背后真实而完整的脉络。
          </p>
        </div>

        <div className="flex flex-col gap-8 md:gap-10">
          {features.map((f, i) => {
            const reverse = i % 2 === 1;
            return (
              <article
                key={f.id}
                className={`group cursor-pointer grid grid-cols-1 lg:grid-cols-2 gap-0 overflow-hidden rounded-2xl border border-background-200 bg-background-100/60 hover:bg-background-100 transition ${
                  reverse ? 'lg:[direction:rtl]' : ''
                }`}
              >
                <div className="relative w-full h-64 md:h-[420px] overflow-hidden lg:[direction:ltr]">
                  <img
                    src={f.image}
                    alt={f.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-4 left-4 inline-flex items-center gap-1 rounded bg-background-50 text-primary-700 border border-background-300 px-2 py-1 text-xs font-bold">
                    <i className="ri-vip-diamond-line text-sm" aria-hidden="true" /> {f.tag}报道
                  </span>
                </div>
                <div className="flex flex-col justify-center p-6 md:p-10 lg:p-12 lg:[direction:ltr]">
                  <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                    <span className="inline-flex items-center gap-1 text-primary-700 font-medium">
                      <i className="ri-timer-line" aria-hidden="true" /> {f.readTime}
                    </span>
                    <span className="w-1 h-1 rounded-full bg-background-300" aria-hidden="true" />
                    <span>编辑部原创</span>
                  </div>
                  <h3 className="font-heading text-xl md:text-3xl font-black leading-snug text-foreground-950 group-hover:text-primary-700 transition">
                    {f.title}
                  </h3>
                  <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{f.excerpt}</p>
                  <a
                    href="#about"
                    className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:gap-3 transition w-fit whitespace-nowrap cursor-pointer"
                  >
                    阅读全文 <i className="ri-arrow-right-line" aria-hidden="true" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}